import { Button } from '@unmind/design-system';
import { tracking } from 'App/Tracking';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getEapServices_helpEAPServices as EapService } from 'Help/hooks/__generated__/getEapServices';

interface ContactButtonProps {
  activeService: EapService;
  contactDetail?: string | false;
  countryCode: string;
  onClick?(e: React.MouseEvent): void;
}

const ContactButton = ({
  activeService,
  contactDetail = false,
  countryCode,
  onClick,
}: ContactButtonProps) => {
  const { t: translate } = useTranslation('help', {
    keyPrefix: 'eap_contact_number',
  });

  const isEmail = contactDetail && contactDetail.includes('@'); // The field is sometimes being used for email; this isn't an ideal solution, but this will be better UX for the data being provided by clients

  let trackingProps: { contactNumber?: string } = {};
  if (contactDetail) {
    trackingProps = {
      contactNumber: contactDetail,
    };
  }

  return (
    <Button
      variant="primary"
      onClick={(e: React.MouseEvent) => {
        tracking.track(
          `help_service_contact_${
            contactDetail ? 'number' : 'service'
          }_clicked`,
          {
            serviceId: activeService.id,
            serviceName: activeService.serviceName,
            countryCode,
            ...trackingProps,
          },
        );
        if (!contactDetail && onClick) onClick(e);
      }}
      {...(contactDetail && {
        to: `${isEmail ? 'mailto' : 'tel'}:${contactDetail}`,
        'aria-label': translate(`a11y_label.${isEmail ? 'email' : 'phone'}`, {
          contactDetail,
        }),
      })}
      label={contactDetail ? contactDetail : translate('cta')}
      icon={{
        icon: isEmail ? 'email' : 'call',
        position: 'left',
      }}
    />
  );
};

export default ContactButton;
